/*
 * Author: Valeria Sinnati
 *
 *  /\_/\
 * ( o.o )
 *  > ^ <
 */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CommentSettings from './CommentSettings';
import ToneArchetypeSettings from './ToneArchetypeSettings';
import './Profile.css';

/*
 *  /\____/\
 * > •    • <   #1
 */
function AgentConfig() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  // Same collapsible-section pattern used in Profile.js — sezioni
  // aperte di default così l'utente vede subito tone archetype e
  // impostazioni commenti.
  const [showToneArchetype, setShowToneArchetype] = useState(true);
  const [showCommentSettings, setShowCommentSettings] = useState(true);

  return (
    <div className="container">
      <div className="title-with-back">
        <button
          className="back-button"
          onClick={() => navigate('/dashboard')}
          title={t('common.back_to_dashboard')}
        >
          <i className="bi bi-arrow-left"></i>
        </button>
        <h1>{t('agent_config.title')}</h1>
      </div>


      {/* Tone archetype — same widget as Profile → identity-of-voice
          for all agents (customer_care / tutor / content / engagement). */}
      <div className="profile-section">
        <button
          type="button"
          className="profile-section-toggle"
          onClick={() => setShowToneArchetype((v) => !v)}
          aria-expanded={showToneArchetype}
        >
          <span className="profile-section-title">{t('profilePage.toneArchetype.title')}</span>
          <span className="profile-section-hint">{t('profilePage.toneArchetype.hint')}</span>
          <span className="profile-section-caret">{showToneArchetype ? '▾' : '▸'}</span>
        </button>
        <div className={`profile-section-content ${showToneArchetype ? 'open' : 'closed'}`}>
          <div className="profile-section-content-inner">
            <ToneArchetypeSettings />
          </div>
        </div>
      </div>

      {/* Social comment-reply settings — same widget as Profile.
          Per-platform: auto-reply, auto-like positive, tone, referral. */}
      <div className="profile-section">
        <button
          type="button"
          className="profile-section-toggle"
          onClick={() => setShowCommentSettings((v) => !v)}
          aria-expanded={showCommentSettings}
        >
          <span className="profile-section-title">{t('comments.settings')}</span>
          <span className="profile-section-hint">{t('comments.settingsDescription')}</span>
          <span className="profile-section-caret">{showCommentSettings ? '▾' : '▸'}</span>
        </button>
        <div className={`profile-section-content ${showCommentSettings ? 'open' : 'closed'}`}>
          <div className="profile-section-content-inner">
            <CommentSettings />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AgentConfig;
